import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// It is used to define our endpoints and allow to create the API slice
export const googleMApi = createApi({
  // The unique key that defines where the Redux store will store our cache.
  reducerPath: 'googleMApi',

  // The base query to request data.
  // RTK Query ships with fetchBaseQuery, which is a lightweight fetch wrapper that automatically handles request headers and response parsing in a manner similar to common libraries like axios.
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_CONNECT}/`,
  }),

  tagTypes: ['GoogleMerchant'],
  // keepUnusedDataFor: 1,
  keepUnusedDataFor: 86400000,
  refetchOnMountOrArgChange: 1,
  // The set of operations that we want to perform against the server.
  endpoints: (builder) => ({
    getAllUsers: builder.query({
      query: (data) => {
        return {
          url: `google_merchant/${data.merchantId}?page=${data.page}&size=${data.size}&searchid=${data.searchid}`,
          method: 'GET',
          headers: {
            'Access-Key': localStorage.getItem('accessKey'),
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.userRole,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
        }
      },
      // keepUnusedDataFor: 1,
      keepUnusedDataFor: 86400000,
      providesTags: ['GoogleMerchant'],
    }),


    fetchGoogleMerchants: builder.query({
      query: (data) => {
        return {
          url: `google_merchants?page=${data.page}&size=${data.size}&searchid=${data.searchid}`,
          method: 'GET',
          headers: {
            'Access-Key': localStorage.getItem('accessKey'),
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.userRole,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
        }
      },
      // keepUnusedDataFor: 1,
      keepUnusedDataFor: 86400000,
      providesTags: ['GoogleMerchant'],
    }),


    createUser: builder.mutation({
      query: (data) => ({
        url: `google_merchant/${data.merchantId}`,
        method: 'POST',
        body: data,
        headers: {
          'Access-Key': localStorage.getItem('accessKey'),
          'X-User-Token': data.userToken,
          'X-User-Id': data.userId,
          'X-User-Role': data.userRole,
          'Accept': 'application/json',
          'Content-type': 'application/json; charset=UTF-8',
        }
      }),
      // keepUnusedDataFor: 1,
      invalidatesTags: ['GoogleMerchant'],
    }),

    createGoogleMrchantAccount: builder.mutation({
      query: (data) => {
        return {
          url: `google_merchants`,
          method: 'POST',
          body: data,
          headers: {
            'Access-Key': localStorage.getItem('accessKey'),
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.userRole,
            'Accept': 'application/json',
            'Content-type': 'application/json; charset=UTF-8',
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['GoogleMerchant'],
    }),


    syncProducts: builder.mutation({
      query: (data) => {
        return {
          url: `google_merchants/${data.merchantId}/${data.country}/${data.storeId}`,
          method: 'POST',
          body: data,
          headers: {
            'Access-Key': localStorage.getItem('accessKey'),
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.userRole,
            'Accept': 'application/json',
            'Content-type': 'application/json; charset=UTF-8',
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['GoogleMerchant'],
    }),



    updateUser: builder.mutation({
      query: (data) => {
        return {
          url: `google_merchant/${data.merchantId}`,
          method: 'PUT',
          body: data,
          headers: {
            'Access-Key': localStorage.getItem('accessKey'),
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.userRole,
            'Accept': 'application/json',
            'Content-type': 'application/json; charset=UTF-8',
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['GoogleMerchant'],
    }),


    updateGoogleMerchantAccount: builder.mutation({
      query: (data) => {
        return {
          url: `google_merchants/${data.id}`,
          method: 'PUT',
          body: data,
          headers: {
            'Access-Key': localStorage.getItem('accessKey'),
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.userRole,
            'Accept': 'application/json',
            'Content-type': 'application/json; charset=UTF-8',
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['GoogleMerchant'],
    }),


    deleteProduct: builder.mutation({
      query: (data) => {
        return {
          url: `google_merchant/${data.merchantId}`,
          method: 'DELETE',
          body: data,
          headers: {
            'Access-Key': localStorage.getItem('accessKey'),
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.admin,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          }
        }
      },
      invalidatesTags: ['GoogleMerchant'],
    }),



  }),

})

// Export hooks for usage in functional components, which are auto-generated based on the defined endpoints
export const {
  useGetAllUsersQuery,
  useCreateUserMutation,
  useUpdateUserMutation,
  useDeleteProductMutation,
  useFetchGoogleMerchantsQuery,
  useCreateGoogleMrchantAccountMutation,
  useUpdateGoogleMerchantAccountMutation,
  useSyncProductsMutation,
} = googleMApi